import { render, staticRenderFns } from "./LandingApp.vue?vue&type=template&id=022e002e&scoped=true&"
import script from "./LandingApp.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandingApp.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LandingApp.vue?vue&type=style&index=0&id=022e002e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e002e",
  null
  
)

export default component.exports